module.exports = __webpack_public_path__ + "img/suit-spade-fill.cd897397.svg";